import { getDefaultSliderSettings } from '../utils/slider.js';
import { Swiper } from './swiper-src.min.js';

export default function initProductTeaserSlider() {
  // Initialize Swiper for each product teaser slider
  document.querySelectorAll('.product-teaser-slider').forEach(el => {
    if (!el) return;
    if (el.querySelector('.scroll-x')) return;

    new Swiper(el, {
      ...getDefaultSliderSettings(el),
      loop: false,
      breakpoints: {
        1430: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 2.5
        },
        526: {
          slidesPerView: 2
        }
      }
    });
  });
}

let init = false;
let swiper;
function swiperOnlyMobile() {
  document.querySelectorAll('.product-teaser .scroll-x .swiper-placeholder').forEach(el => {
    if (!el) return;

    if (window.innerWidth <= 768) {
      if (!init) {
        updateSwiperClasses(el, false);
        init = true;
        swiper = new Swiper(el, {
          ...getDefaultSliderSettings(el)
        });
      }
    } else if (init) {
      updateSwiperClasses(el, true);
      swiper.destroy();
      init = false;
    }
  });
}
swiperOnlyMobile();
window.addEventListener('resize', swiperOnlyMobile);

function updateSwiperClasses(el, remove) {
  if (remove) {
    el.classList.remove('swiper');
    el.querySelector('.swiper-wrapper-placeholder').classList.remove('swiper-wrapper');
    el.querySelectorAll('.swiper-slide-placeholder').forEach(slide => {
      slide.classList.remove('swiper-slide');
    });
  } else {
    el.classList.add('swiper');
    el.querySelector('.swiper-wrapper-placeholder').classList.add('swiper-wrapper');
    el.querySelectorAll('.swiper-slide-placeholder').forEach(slide => {
      slide.classList.add('swiper-slide');
    });
  }
}
